import ArrowLeftIcon from '@eduzz/houston-icons/ArrowLeft';
import { useFormikContext } from 'formik';
import * as React from 'react';

import { useStepper } from '../../../context';
import { useStyles } from './styles';

function BackButton() {
  const { prevStep, isFirst } = useStepper();
  const classes = useStyles();
  const formik = useFormikContext();

  if (isFirst || formik?.status === 'submitted') return null;

  return (
    <button id='step-back-btn' className={classes.root} onClick={prevStep} disabled={formik?.isSubmitting}>
      <ArrowLeftIcon className={classes.icon} />
      Voltar
    </button>
  );
}

export { BackButton };
